export const dashboardApi = {
    getDashboardCounts: 'v1/api/application/adminDashboard',
    getPowerBi: 'v1/powerbi/embed-token',
    getPowerBi2: 'v1/powerbi/embed-token2',
    getUpdateService: 'v1/api/users/update'
}